import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invitationconfirmation',
  templateUrl: './invitationconfirmation.component.html',
  styleUrls: ['./invitationconfirmation.component.less']
})
export class InvitationconfirmationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
